<template>
  <tr class="row-details" v-if="readyToRender">
    <td class="v-align-middle"  colspan="6">
      <div class="rp_container">
        <customer 
          :customer="customer" 
          :is-details="isDetails"
        ></customer>

        <div class="rp-representatives">
          <div class="rp-representatives-head">
            <h4>Réprésentant(s) concerné(s)</h4>
          </div>

          <validation-representative
            v-if="'representative-mainification' === validationRequest.included.type.attributes.name && customerMainRepresentative"
            :representative="customerMainRepresentative"
            :current="true"
          ></validation-representative>
          
          <validation-representative 
            :representative="validationRequestable"
            :current="false"
          ></validation-representative>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { apiV2 } from 'store/api'
import Customer from "./ValidationRequestable/CustomerV2"
import ValidationRepresentative from "./ValidationRequestable/RepresentativeV2"

export default {
  name:"Representative",

  props:["validationRequestId", "isDetails"],

  components:{
    Customer,
    ValidationRepresentative
  },

  data() {
    return {
      validationRequest: null
    }
  },

  computed:{
    readyToRender() {
      return this.validationRequest != null
    },

    customer() {
      return this.validationRequest.included.customer
    },

    customerMainRepresentative() {
      return this.customer && this.customer.included.main_representative
       ? this.customer.included.main_representative
       : null
    },

    validationRequestable() {
      return this.validationRequest.included.validation_requestable
    }
  },

  created() {
    const params = {
      with: 'type,customer.main_representative,validation_requestable'
    }

    apiV2.getValidationRequest(this.validationRequestId, params)
      .then((response) => this.validationRequest = response.data.data)
  }
}
</script>

<style scoped>
.rp_container {
  display: flex;
}

.rp_container > div { margin-right: 15px; }
.rp_container > div:last-child { margin-right: 0; }

.rp-representatives {
  border:solid 1px lightgrey;
  padding: 0 15px;
  background-color: white;
  width: 100%;
}

.rp-representatives .validation_request_representative { margin-bottom: 15px; }

.row-details td {
  background-color: #e0e0e0
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/Representative.vue